<template>
<section class="w-full mx-auto h-full px-4 sm:px-6 lg:px-4 py-4 bg-gray-100 content-start flex flex-wrap">

    <div class="w-full flex flex-wrap justify-start conten-start h-full">
        <div class="  w-full flex flex-wrap justify-start content-start h-2/6 py-2">
            <div class="bg-white rounded-lg p-12 flex flex-col justify-center content-start w-3/6">
                <h1 class="font-bold text-xl  font-heading text-gray-900">
                    Metricas de vendedores

                </h1>
                <h1 class="font-bold mt-2  font-heading text-gray-900 w-full flex flex-wrap justify-center content-center">
                    <select class="w-full bg-gray-100 my-1 rounded-md h-12 text-center " v-model="vendedor">
                        <option v-for="(row,i) in data_vendedores" :value="row.id" v-bind:key="i">{{row.name}}</option>
                    </select>
                    <div class="w-full flex flex-wrap justify-center content-center my-1">
                        <div class="w-6/12  flex flex-wrap justify-start">
                            <el-date-picker class="w-full" v-model="fechaInicio" type="date" placeholder="Fecha de inicio" :default-value="getDefaultStartDate"></el-date-picker>

                        </div>
                        <div class="w-6/12 flex flex-wrap justify-start">
                            <el-date-picker v-model="fechaFin" type="date" placeholder="Fecha de fin" :default-value="getDefaultEndDate"></el-date-picker>

                        </div>
                    </div>

                    <el-button class="w-full" type="primary" @click="applyDateRange">Aplicar</el-button>
                </h1>
            </div>

            <div class="w-3/6 p-2 h-full overflow-hidden">

                <DynamicChart v-if="data_citas != null" :endpoint="'?user='+vendedor+'&fecha_inicio='+formatDateEN(fechaInicio)+'&fecha_fin='+formatDateEN(fechaFin)" chartType="bar" chartLabel="Ventas"></DynamicChart>

            </div>

        </div>
        <div class=" w-full   flex flex-wrap  justify-start content-start h-4/6 py-2 space-x-1 bg-gray-100">

            <div class="flex flex-wrap w-full sticky top-0 mt-1 bg-white">
                <div class="mb-0 flex space-x-4 p-2 bg-white  shadow-md w-full">
                    <button v-on:click="openTab = 1" :class="{ 'bg-gray-600 text-white': openTab === 1 }" class="flex-1 py-2 px-4 rounded-md focus:outline-none focus:shadow-outline-blue transition-all duration-300">Citas</button>
                    <button v-on:click="openTab = 2" :class="{ 'bg-gray-600 text-white': openTab === 2 }" class="flex-1 py-2 px-4 rounded-md focus:outline-none focus:shadow-outline-blue transition-all duration-300">Ventas</button>
                    <button v-on:click="openTab = 3" :class="{ 'bg-gray-600 text-white': openTab === 3 }" class="flex-1 py-2 px-4 rounded-md focus:outline-none focus:shadow-outline-blue transition-all duration-300">Garantias de venta</button>

                    <button v-on:click="openTab = 4" :class="{ 'bg-gray-600 text-white': openTab === 4 }" class="flex-1 py-2 px-4 rounded-md focus:outline-none focus:shadow-outline-blue transition-all duration-300">Garantias responsables</button>

                </div>
            </div>

            <div v-if="openTab === 1" class="transition-all duration-300 bg-white  rounded-lg shadow-md  w-full h-full">
                <div class="rounded-md bg-gray-100 overflow-y-scroll h-full w-full">
                    <Tabla v-if="data_citas != null" :columns="headings_citas" :rows="data_citas.data" :filtros="['cliente','vendedor']" :buscarp="buscar" :filtroApi="false" />

                </div>
            </div>

            <div v-if="openTab === 2" class="transition-all duration-300 bg-white p-4 rounded-lg shadow-md w-full h-full">
                <div class="rounded-md bg-gray-100 overflow-y-scroll h-full w-full">
                    <Tabla v-if="data_ventas != null" :columns="headings_ventas" :rows="data_ventas.data" :filtros="['cliente','vendedor']" :buscarp="buscar" :filtroApi="false" />

                </div>
            </div>

            <div v-if="openTab === 3" class="transition-all duration-300 bg-white p-4 rounded-lg shadow-md  w-full h-full">
                <div class="rounded-md bg-gray-100 overflow-y-scroll h-full w-full">
                    <Tabla v-if="data_garantias_venta != null" :columns="headings_garantias" :rows="data_garantias_venta.data" :filtros="['cliente','vendedor']" :buscarp="buscar" :filtroApi="false" />

                </div>
            </div>
            <div v-if="openTab === 4" class="transition-all duration-300 bg-white p-4 rounded-lg shadow-md  w-full h-full">
                <div class="rounded-md bg-gray-100 overflow-y-scroll h-full w-full">
                    <Tabla v-if="data_garantias_responsable != null" :columns="headings_garantias" :rows="data_garantias_responsable.data" :filtros="['cliente','vendedor']" :buscarp="buscar" :filtroApi="false" />

                </div>
            </div>

        </div>
    </div>

    <!-- Selector de fecha inicio y fecha fin -->

    <!-- Resto del contenido del componente -->
    <!-- <div v-if="data_reporte != null" :class="{'flex-row': !IsMov(), 'flex-row-reverse': IsMov()}" class="w-full h-12 bg-gray-100 flex flex-wrap content-center justify-between px-2">
        <div class="w-10/12" :class="{'justify-end': IsMov(), 'justify-center': !IsMov()}">
          <el-pagination v-model:currentPage="pagina" small background layout="prev, pager, next" :page-size="data_reporte['per_page']" :total="Number(data_reporte['total'])" @current-change="pageChangue" />
        </div>
      </div>-->

</section>
</template>

<script>
import {
    ref,
    onMounted,
    onBeforeUnmount
} from 'vue';
import {
    emitter
} from '@/mitt.js';
import {
    useUserStore
} from '@/stores/user';
import generales from '@/functions/generales';
import reportes from '@/Services/reportes';
import vendedores from '@/Services/user';
import DynamicChart from '@/components/charts/DynamicChart.vue';
import {
    filter
} from 'lodash';
import Tabla from "@/components/Tabla.vue";

export default {
    components: {
        Tabla,
        DynamicChart
    },
    mixins: [generales],
    setup() {
        const user = useUserStore();
        const key = ref(0);
        const openTab = ref(1)
        const buscar = ref('all');
        const pagina = ref(1);
        const fechaInicio = ref(getDefaultStartDate());
        const fechaFin = ref(getDefaultEndDate());
        const data_reporte = ref(null);
        const data_ventas = ref(null);
        const data_citas = ref(null);
        const data_garantias_responsable = ref(null);
        const data_garantias_venta = ref(null);
        const vendedor = ref(null);

        const data_vendedores = ref(null)
        const headings_ventas = ref([

            {
                key: 'id',
                tipo: '',
                name: '# Cotización ',
                show: true,
                class: '!bg-blue-100 text-blue-500 font-extrabold w-[200px]'
            },

            {
                key: 'idventa',
                tipo: '',
                name: '# Pedido ',
                show: true,
                class: '!bg-blue-100 text-blue-500 font-extrabold w-[200px]'
            },

            {
                key: 'fecha_pedido',
                tipo: '',
                name: 'Fecha de pedido ',
                show: true,
                class: '!bg-blue-100 text-blue-500 font-extrabold w-[200px]'
            },
            {
                key: 'contacto',
                tipo: '',
                name: 'Cliente ',
                show: true,
                class: '!bg-blue-100 text-blue-500 font-extrabold w-[200px]'
            },

            {
                key: 'total',
                tipo: '',
                name: 'Total ',
                show: true,
                class: '!bg-blue-100 text-blue-500 font-extrabold w-[200px]'
            },
            {
                key: 'origen',
                tipo: '',
                name: 'Origen',
                show: true,
                class: '!bg-green-100 text-green-500 font-extrabold w-[200px]'
            },

        ])
        const headings_citas = ref([

            {
                key: 'cotizaciones_id',
                tipo: '',
                name: '# Cotización ',
                show: true,
                class: '!bg-blue-100 text-blue-500 font-extrabold w-[200px]'
            },

            {
                key: 'idventa',
                tipo: '',
                name: '# Pedido ',
                show: true,
                class: '!bg-blue-100 text-blue-500 font-extrabold w-[200px]'
            },
            {
                key: 'cliente',
                tipo: '',
                name: 'Cliente ',
                show: true,
                class: '!bg-blue-100 text-blue-500 font-extrabold w-[200px]'
            },
            {
                key: 'origen',
                tipo: '',
                name: 'Origen ',
                show: true,
                class: '!bg-blue-100 text-blue-500 font-extrabold w-[200px]'
            },

            {
                key: 'monto_cotizacion',
                tipo: 'format_price',
                name: 'monto_cotizacion ',
                show: true,
                class: '!bg-blue-100 text-blue-500 font-extrabold w-[200px]'
            },
            {
                key: 'monto_venta',
                tipo: 'format_price',
                name: 'monto_venta',
                show: true,
                class: '!bg-green-100 text-green-500 font-extrabold w-[200px]'
            },
            {
                key: 'fecha_inicio',
                tipo: '',
                name: 'fecha',
                show: true,
                class: '!bg-green-100 text-green-500 font-extrabold w-[200px]'
            },

        ])

        const headings_garantias = ref([

            {
                key: 'id',
                tipo: '',
                name: '# Cotización Garantia ',
                show: true,
                class: '!bg-blue-100 text-blue-500 font-extrabold w-[100px]'
            },
            {
                key: 'garantia',
                tipo: '',
                name: '# Cotización origen',
                show: true,
                class: '!bg-blue-100 text-blue-500 font-extrabold w-[100px]'
            },

            {
                key: 'idventa',
                tipo: '',
                name: '# Pedido ',
                show: true,
                class: '!bg-blue-100 text-blue-500 font-extrabold w-[100px]'
            },
            {
                key: 'contacto',
                tipo: '',
                name: 'Cliente ',
                show: true,
                class: '!bg-blue-100 text-blue-500 font-extrabold w-[150px]'
            },

            {
                key: 'fecha_pedido',
                tipo: '',
                name: 'Fecha de pedido ',
                show: true,
                class: '!bg-blue-100 text-blue-500 font-extrabold w-[100px]'
            },

            {
                key: 'total',
                tipo: '',
                name: 'Total ',
                show: true,
                class: '!bg-blue-100 text-blue-500 font-extrabold w-[100px]'
            },
            {
                key: 'detalle_garantia',
                tipo: '',
                name: 'Detalle Garantia',
                show: true,
                class: '!bg-green-100 text-green-500 font-extrabold w-[500px] text-wrap'
            },

        ])

        const pageChangue = (val) => {
            pagina.value = val;
            getData();
        }
        const getData = async () => {
            await getDataVentas();
            await getDataCitas();
            await getDataGarantias_ventas();
            await getDataGarantias_responsable();
        }
        const applyDateRange = () => {
            getData();
        }

        const getDataVentas = async () => {
            emitter.emit('loading', true);
            let dat = {
                //  page: pagina.value,
                fechaInicio: formatFecha(fechaInicio.value), // Pasa la fecha de inicio
                fechaFin: formatFecha(fechaFin.value),
                id: vendedor.value // Pasa la fecha de fin
            }
            await reportes.GET_VENDEDOR_VENTAS(dat).then((response) => {
                if (response != null && !response.hasOwnProperty('error')) {
                    data_ventas.value = response;
                } else {
                    // emitter.emit("alerta_show",response.msg);
                }
                emitter.emit('loading', false);
            });
        }
        const getVendedores = async () => {
            emitter.emit('loading', true);
            let dat = {
                page: 1,
                limit: 200,
                search: 'all'
            }
            await vendedores.GET_USUARIOS(dat).then((response) => {
                if (response != null && !response.hasOwnProperty('error')) {
                    data_vendedores.value = response;

                    if (response.length > 0) {
                        vendedor.value = response[0].id;
                        getData();
                    }
                } else {
                    // emitter.emit("alerta_show",response.msg);
                }
                emitter.emit('loading', false);
            });
        }
        const getDataCitas = async () => {
            emitter.emit('loading', true);
            let dat = {
                //  page: pagina.value,
                fechaInicio: formatFecha(fechaInicio.value), // Pasa la fecha de inicio
                fechaFin: formatFecha(fechaFin.value),
                id: vendedor.value // Pasa la fecha de fin
            }
            await reportes.GET_VENDEDOR_CITAS(dat).then((response) => {
                if (response != null && !response.hasOwnProperty('error')) {
                    data_citas.value = response;
                } else {
                    // emitter.emit("alerta_show",response.msg);
                }
                emitter.emit('loading', false);
            });
        }
        const getDataGarantias_ventas = async () => {
            emitter.emit('loading', true);
            let dat = {
                //  page: pagina.value,
                fechaInicio: formatFecha(fechaInicio.value), // Pasa la fecha de inicio
                fechaFin: formatFecha(fechaFin.value),
                id: vendedor.value // Pasa la fecha de fin
            }
            await reportes.GET_VENDEDOR_GARANTIAS_VENTA(dat).then((response) => {
                if (response != null && !response.hasOwnProperty('error')) {
                    data_garantias_venta.value = response;
                } else {
                    // emitter.emit("alerta_show",response.msg);
                }
                emitter.emit('loading', false);
            });
        }
        const getDataGarantias_responsable = async () => {
            emitter.emit('loading', true);
            let dat = {
                //  page: pagina.value,
                fechaInicio: formatFecha(fechaInicio.value), // Pasa la fecha de inicio
                fechaFin: formatFecha(fechaFin.value),
                id: vendedor.value // Pasa la fecha de fin
            }
            await reportes.GET_VENDEDOR_GARANTIAS_RESPONSABLE(dat).then((response) => {
                if (response != null && !response.hasOwnProperty('error')) {
                    data_garantias_responsable.value = response;
                } else {
                    // emitter.emit("alerta_show",response.msg);
                }
                emitter.emit('loading', false);
            });
        }
        const formatFecha = (fecha) => {
            const dateObj = new Date(fecha);
            return dateObj.toISOString();
            const formattedDate = `${dateObj.getDate()}/${dateObj.getMonth() + 1}/${dateObj.getFullYear()}`;
            return formattedDate;
        }
        // Función para obtener el primer día del mes actual
        function getDefaultStartDate() {
            const today = new Date();
            return new Date(today.getFullYear(), today.getMonth(), 1);
        }

        // Función para obtener el último día del mes actual
        function getDefaultEndDate() {
            const today = new Date();
            return new Date(today.getFullYear(), today.getMonth() + 1, 0);
        }

        onMounted(async () => {
            getVendedores();
            /* await getDataVentas();
           await getDataCitas();
           await getDataGarantias();
*/
        })

        onBeforeUnmount(() => {
            // Add any cleanup logic here.
        })

        return {
            getVendedores,
            data_vendedores,
            headings_ventas,
            getData,
            pageChangue,
            buscar,
            openTab,
            key,
            data_reporte,
            fechaInicio,
            fechaFin,
            applyDateRange,
            vendedor,
            data_ventas,
            data_citas,
            data_garantias_responsable,
            data_garantias_venta,
            headings_garantias,
            headings_citas
        };
    },
};
</script>

<style scoped>
/* Your component-specific styles here */
</style>
